var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3010_14106)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF4500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 12.6634C20.25 11.6338 19.4263 10.8101 18.3966 10.913C17.9848 10.913 17.47 11.119 17.1611 11.4278C15.7196 10.5012 14.0722 9.88339 12.3218 9.88339L13.1455 5.97075L15.8225 6.58853C15.8225 7.30928 16.4403 7.8241 17.1611 7.8241C17.8818 7.8241 18.3966 7.20632 18.3966 6.48557C18.3966 5.76482 17.7789 5.25 17.0581 5.25C16.5433 5.25 16.1314 5.55889 15.9255 5.97075L13.0425 5.25H12.8366C12.7336 5.25 12.7336 5.35296 12.7336 5.45593L11.704 9.88339C9.95359 9.88339 8.30616 10.3982 6.86466 11.4278C6.14392 10.7071 5.01131 10.7071 4.29056 11.4278C3.56981 12.1486 3.56981 13.2812 4.29056 14.0019C4.39353 14.1049 4.59945 14.3108 4.80538 14.3108V14.8257C4.80538 17.6057 7.99727 19.8709 12.0129 19.8709C16.0285 19.8709 19.2204 17.6057 19.2204 14.8257V14.3108C19.8381 14.0019 20.25 13.3842 20.25 12.6634V12.6634ZM7.89431 14.0019C7.89431 13.2812 8.51209 12.7664 9.12987 12.7664C9.85062 12.7664 10.3654 13.3842 10.3654 14.0019C10.3654 14.6197 9.74766 15.2375 9.12987 15.2375C8.40913 15.2375 7.89431 14.7227 7.89431 14.0019ZM15.1018 17.3998C14.1751 18.0175 13.1455 18.4294 12.0129 18.3264C10.8803 18.3264 9.85062 18.0175 8.92395 17.3998C8.82098 17.2968 8.82098 17.0909 8.92395 16.8849C9.02691 16.782 9.23284 16.782 9.3358 16.8849C10.0566 17.3998 10.9832 17.7087 11.9099 17.6057C12.8366 17.7087 13.7633 17.3998 14.484 16.8849C14.587 16.782 14.7929 16.782 14.9988 16.8849C15.2048 16.9879 15.2048 17.1938 15.1018 17.3998ZM14.7929 15.2375C14.0722 15.2375 13.5573 14.6197 13.5573 14.0019C13.5573 13.3842 14.1751 12.7664 14.7929 12.7664C15.5136 12.7664 16.0285 13.3842 16.0285 14.0019C16.1314 14.7227 15.5136 15.2375 14.7929 15.2375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3010_14106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.574200b1e9e14992049591643a704bd8.svg";
export { ForwardRef as ReactComponent };